import { render, staticRenderFns } from "./classifierCreate.vue?vue&type=template&id=17074641&"
import script from "./classifierCreate.vue?vue&type=script&lang=js&"
export * from "./classifierCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports